<template>
    <cardTodoNoOrder v-if="visitaSinPedido || visitaComentarios"/>
    <cardCreateTodo v-else/>
</template>
<script>

import cardCreateTodo from '@/components/cardCreateTodo.vue'
import cardTodoNoOrder from '@/components/cardTodoNoOrder.vue'
export default {
    name: 'VistaVisita',
    data () {
      return {             
      }
    },
    methods:{                
        
    },
    watch:{
        
    },
    computed: {  
        visitaSinPedido: {
            get(){
                return this.$store.state.visitaSinPedido;
            }, 
            set(value){

            }
        },
        visitaComentarios: {
            get(){
                return this.$store.state.visitaComentarios;
            }, 
            set(value){

            }
        }
    },
    components: {
        cardCreateTodo,
        cardTodoNoOrder
    }
}
</script>
